module.exports = __webpack_public_path__ + "img/icon-7.8885569d.svg";